import { AuthPanelCode, AuthPanelEmail, AuthPanelPassword, AuthPanelProfile } from '@/features/auth'
import type { CatalogComponentEntry } from './component-registry.types'
import {
  AuthPanelCodeCatalogPreview,
  AuthPanelEmailCatalogPreview,
  AuthPanelPasswordCatalogPreview,
  AuthPanelProfileCatalogPreview,
} from './responsive-previews'

export const featuresRegistryEntries: CatalogComponentEntry[] = [
  {
    name: 'AuthPanelEmail',
    path: 'features/auth/ui/auth-panel-email',
    layer: 'features',
    description: 'Email + agreement auth step (desktop/mobile).',
    component: AuthPanelEmail,
    render: () => <AuthPanelEmailCatalogPreview />,
  },
  {
    name: 'AuthPanelCode',
    path: 'features/auth/ui/auth-panel-code',
    layer: 'features',
    description: 'Verification code auth step (desktop/mobile).',
    component: AuthPanelCode,
    render: () => <AuthPanelCodeCatalogPreview />,
  },
  {
    name: 'AuthPanelPassword',
    path: 'features/auth/ui/auth-panel-password',
    layer: 'features',
    description: 'Email + password auth step (desktop/mobile).',
    component: AuthPanelPassword,
    render: () => <AuthPanelPasswordCatalogPreview />,
  },
  {
    name: 'AuthPanelProfile',
    path: 'features/auth/ui/auth-panel-profile',
    layer: 'features',
    description: 'Profile details auth step (desktop/mobile).',
    component: AuthPanelProfile,
    render: () => <AuthPanelProfileCatalogPreview />,
  },
]
